import * as React from "react";
import { Box, Paper, Typography, Divider, Grid } from "@mui/material";
import { Container } from "../Inicio/syles";
import { MenuLateral } from "../../../../Components/MenuLateral/Index";
import { usePrefeitura } from "../../../../Hooks/usePrefeitura";
import { useFuncionarioPrefeitura } from "../../../../Hooks/funcionarioPrefeitura";
import { useCartorio } from "../../../../Hooks/cartorio";
import { SeletorPeriodo } from "../../../../Components/Relatorios/SeletoresRelatorio";
import { Header } from "../../../../Components/Header";
import { Tabela } from "../../../../Components/Relatorios/Tabela";

export function Relatorios() {
  const { prefeituraIsLogged, prefeitura } = usePrefeitura();
  const { funcionarioPrefeituraIsLogged } = useFuncionarioPrefeitura();
  const { cartorio } = useCartorio();

  const tituloMenu =
    prefeituraIsLogged || funcionarioPrefeituraIsLogged
      ? prefeitura.NOME
      : cartorio.NOME;

  return (
    <>
      <MenuLateral titulo={tituloMenu} />

      <Container>
        <Box
          sx={{
            minHeight: "100vh",
            background: "#f5f7fb",
            px: 2,
            py: 1.5, // 🔥 menor
            mt:6
          }}
        >
          <Box sx={{ width: "100%", mx: "auto" }}>
            <Grid container spacing={2}> {/* 🔥 menor */}
              
              {/* FILTROS */}
              <Grid item xs={12}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2, // 🔥 menor
                    borderRadius: 2,
                    border: "1px solid #e5e7eb",
                    backgroundColor: "#fff",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mb: 1, // 🔥 menor
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "0.95rem", // 🔥 menor
                      }}
                    >
                      Filtros
                    </Typography>

                    <Typography
                      sx={{
                        color: "#6b7280",
                        fontSize: "0.8rem", // 🔥 menor
                      }}
                    >
                      Ajuste os parâmetros
                    </Typography>
                  </Box>

                  {/* 🔥 sem divider (economiza espaço) */}
                  <SeletorPeriodo />
                </Paper>
              </Grid>

              {/* RESULTADO */}
              <Grid item xs={12}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 1.5, // 🔥 menor
                    borderRadius: 2,
                    border: "1px solid #e5e7eb",
                    backgroundColor: "#fff",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "0.95rem",
                      }}
                    >
                      Resultado
                    </Typography>
                  </Box>

                  <Tabela tipo="todos" />
                </Paper>
              </Grid>

            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
}